import protectedAxiosRequest from '../../helpers/protectedAxiosRequest';

const baseUrl = process.env.REACT_APP_ANALYTICS_ENDPOINT;

export const getPosts = params =>
  protectedAxiosRequest.get(`${baseUrl}/api/posts`, { params });

export const getComments = params =>
  protectedAxiosRequest.get(`${baseUrl}/api/comments`, { params });

export const addNewVideoAndComments = params =>
  protectedAxiosRequest.get(`${baseUrl}/api/comments-by-link`, { params });

export const fetchPostComments = (payload, params) =>
  protectedAxiosRequest.post(
    `${baseUrl}/api/source-post/source-comments`,
    payload,
    { params },
  );

export const addFeedback = payload =>
  protectedAxiosRequest.post(`${baseUrl}/api/feedback`, payload);
